import { render } from "./NotificationDropdown.vue?vue&type=template&id=480c19ba&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=480c19ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480c19ba"]])

export default __exports__